function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStarFill = function SvgIconStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    stroke: props.color,
    d: "M21.864 9.407a.47.47 0 0 0-.274-.146l-6.33-.965-2.83-6.016a.468.468 0 0 0-.859 0l-2.83 6.016-5.608.855-.723.11a.499.499 0 0 0-.405.569c.015.109.064.21.14.287l4.58 4.683-1.081 6.613a.5.5 0 0 0 .39.58c.105.018.211 0 .304-.05L12 18.82l5.08 2.801.582.321a.467.467 0 0 0 .646-.21.525.525 0 0 0 .048-.319l-.092-.563-.99-6.05 4.581-4.683a.52.52 0 0 0 .01-.71z",
    clipRule: "evenodd"
  }));
};
export default SvgIconStarFill;